import { brandCodeMap } from '@/constants';
import { comm, base } from '../base';

const tblTheme = {};

for (const item of Object.keys(brandCodeMap)) {
  tblTheme[item] = {
    table: {
      thHeadColor: comm.color.cffff,
      thHeadBckColor: base[item]?.tblColor.c0023,
      bgColor: base[item]?.tblColor.c0007,
      // rowColor: base[item]?.tblColor.c0005,
      rowColor: base[item]?.tblColor.c0040,
      rowHoverColor: base[item]?.tblColor.ac0027,
      focusBorderColor: base[item]?.tblColor.c0028,
    },
  };
}

export const table = tblTheme;
